fragment WidgetCollapsedFragment on Widget {
    id
    isCollapsedForUser
}
